/**
 * TanStack Query hooks for `help-center`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	helpCenterQueryKeys,
	type CreateHelpCenterBody,
	type ListHelpCenterResponse,
	type HelpCenterRow,
} from "./api";

export function useHelpCenterList(): UseQueryResult<ListHelpCenterResponse, Error> {
	return useQuery({
		queryKey: helpCenterQueryKeys.list(),
		queryFn: list,
	});
}

export function useHelpCenterCreate(): UseMutationResult<HelpCenterRow, Error, CreateHelpCenterBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: helpCenterQueryKeys.all });
		},
	});
}

export function useHelpCenterDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: helpCenterQueryKeys.all });
		},
	});
}
